import React from "react";

import { Container } from "@mui/material";
import HeaderHelpPage from "../../components/HeaderHelpPage";
import ProductUpdateList from "./view";

const ProductUpdate = ({ userRole }) => {
  return (
    <Container>
      <HeaderHelpPage
        title="Notifications"
        description="The process of releasing new features, improvements, and bug fixes to a product."
      />
      <ProductUpdateList userRole={userRole} />
    </Container>
  );
};

export default ProductUpdate;
